function MetaAds(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="14" viewBox="0 0 20 14" fill="none" {...props}>
      <g id="Group 48096459">
        <path
          id="Vector"
          d="M19.9999 9.00386L19.0464 9.7269L18.0955 9.06473C18.0955 8.99517 18.0955 8.92125 18.0912 8.84734C18.0912 8.77778 18.0912 8.70386 18.0868 8.62995C18.026 6.91692 17.5912 5.08215 16.7216 3.73868C16.0521 2.70825 15.1955 2.21695 14.239 2.21695C13.2347 2.21695 12.4173 2.81695 11.513 4.12129C11.4869 4.16042 11.4564 4.19955 11.4304 4.24303C11.413 4.26477 11.3999 4.2865 11.3825 4.31259C11.3391 4.37781 11.2956 4.44303 11.2521 4.51259C10.8608 5.12128 10.4521 5.82997 10.0086 6.61258C9.9695 6.68649 9.92602 6.7604 9.88689 6.83431C9.87384 6.8517 9.8608 6.87344 9.8521 6.89083L9.7608 7.0517L9.22167 8.00387C7.95647 10.243 7.63473 10.756 7.0043 11.5951C5.89561 13.0691 4.94779 13.6299 3.69997 13.6299C2.22172 13.6299 1.2826 12.9908 0.704343 12.0256C0.230433 11.243 0 10.2125 0 9.03864L2.16085 9.11256C2.16085 9.87777 2.32607 10.4604 2.54781 10.8169C2.83476 11.2778 3.2565 11.456 3.69563 11.456C4.25649 11.456 4.77823 11.3386 5.76953 9.96472C6.56517 8.86473 7.50429 7.32561 8.13472 6.35605L8.73037 5.44737L8.85646 5.24737L8.98689 5.05172L9.20428 4.71694C9.53472 4.21259 9.89123 3.67781 10.2738 3.16477C10.3173 3.1039 10.3608 3.04303 10.4086 2.98217C10.4521 2.9213 10.4999 2.86043 10.5434 2.80391C10.9347 2.30391 11.3477 1.8387 11.7912 1.45609C12.5956 0.756094 13.4608 0.369141 14.3347 0.369141C15.7999 0.369141 17.1955 1.21696 18.2651 2.80825C19.3564 4.43433 19.9259 6.4604 19.9912 8.56908C19.9955 8.63865 19.9955 8.71256 19.9955 8.78647C19.9999 8.86038 19.9999 8.92995 19.9999 9.00386Z"
          fill="#0081FB"
        />
        <path
          id="Vector_2"
          d="M1.70361 2.95869C2.69361 1.43479 4.12316 0.369141 5.76228 0.369141C6.71184 0.369141 7.65531 0.649573 8.64096 1.45305C9.71877 2.3313 10.8679 3.77738 12.3014 6.16084L12.8153 7.01605C14.0561 9.07951 14.7618 10.1408 15.1753 10.6417C15.7066 11.2847 16.0383 11.456 16.5218 11.456C17.7478 11.456 18.0944 10.3517 18.0944 9.0643L20 9.00473C20 10.3504 19.7344 11.3391 19.2822 12.1199C18.8457 12.8751 17.9944 13.6299 16.5622 13.6299C15.6718 13.6299 14.8831 13.4369 14.0109 12.6156C13.3405 11.9851 12.5566 10.8652 11.9535 9.85864L10.1596 6.86779C9.25965 5.36693 8.434 4.24737 7.95618 3.74086C7.44227 3.19564 6.80749 2.54347 5.75315 2.54347C4.89968 2.54347 4.14925 3.13564 3.54273 4.04998L1.70361 2.95869Z"
          fill="url(#paint0_linear_3787_4631)"
        />
        <path
          id="Vector_3"
          d="M5.76083 2.54304C4.9091 2.54304 4.15954 3.13521 3.55432 4.04955C2.69824 5.34171 2.1739 7.26605 2.1739 9.1143C2.1739 9.87646 2.17259 10.4499 2.39129 10.8038L0.721734 12.0269C0.249564 11.2417 0 10.2386 0 9.06473C0 6.92996 0.589126 4.67737 1.70347 2.95869C2.69215 1.43479 4.13345 0.369141 5.76952 0.369141L5.76083 2.54304Z"
          fill="url(#paint1_linear_3787_4631)"
        />
        <path
          id="Vector_4"
          opacity="0.05"
          d="M8.98699 5.0525L8.85656 5.24815L8.73047 5.44815C9.03916 5.89597 9.39133 6.4351 9.7609 7.05248L9.8522 6.89161C9.8609 6.87422 9.87394 6.85249 9.88698 6.83509C9.92611 6.76118 9.96959 6.68727 10.0087 6.61336C9.64785 6.02206 9.30003 5.49597 8.98699 5.0525ZM10.4087 2.98295C10.3609 3.04382 10.3174 3.10469 10.2739 3.16555C10.5913 3.5612 10.9131 4.00903 11.2522 4.51337C11.2957 4.44381 11.3391 4.37859 11.3826 4.31337C11.4 4.28729 11.4131 4.26555 11.4305 4.24381C11.4565 4.20033 11.487 4.1612 11.5131 4.12207C11.1826 3.63512 10.8609 3.19599 10.5435 2.80469C10.5 2.86121 10.4522 2.92208 10.4087 2.98295Z"
          fill="black"
        />
        <path
          id="Vector_5"
          opacity="0.07"
          d="M8.98712 5.05197L8.85669 5.24762C9.16538 5.6911 9.51321 6.22153 9.88712 6.83457C9.92625 6.76066 9.96972 6.68674 10.0089 6.61283C9.64799 6.02153 9.30016 5.49545 8.98712 5.05197ZM10.2741 3.16503C10.5915 3.56068 10.9132 4.0085 11.2523 4.51285C11.2958 4.44328 11.3393 4.37806 11.3828 4.31285C11.048 3.8172 10.7219 3.37372 10.4089 2.98242C10.361 3.04329 10.3175 3.10416 10.2741 3.16503Z"
          fill="black"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_3787_4631"
          x1="17.9583"
          y1="6.99953"
          x2="5.44924"
          y2="6.99953"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0081FB" />
          <stop offset="0.995" stopColor="#0064E1" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3787_4631"
          x1="2.88476"
          y1="10.5299"
          x2="2.88476"
          y2="1.89609"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0081FB" />
          <stop offset="0.995" stopColor="#0064E1" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default MetaAds
